export const homeEsTranslation = {
  home: {
    welcomeText: "Welcome,",
    missingPaymentMethodsMessage: {
      heading: "Agregar un método de pago",
      content:
        "Necesitamos un método de pago registrado para procesar su alquiler. Puede agregar una tarjeta o vincular su banco.",
      paymentScreenContent:
        "Necesitamos un método de pago registrado para procesar su alquiler. Puede agregar una tarjeta o vincular su banco. También puede configurar la opción de Pago automático, una vez que agregue su método de pago predeterminado.",
    },
    isNotAcceptPaymentStatus: {
      heading: "no se puede procesar el pago",
      content:
        "En este momento, no podemos aceptar pagos en línea de su saldo. Su cuenta solo puede recibir el pago completo a través de fondos certificados. Comuníquese con el equipo de la propiedad si tiene alguna pregunta.",
    },
    renewalBanner: {
      title: "¡Es hora de renovar su contrato de arrendamiento!",
      link: "Haga clic aquí",
      reviewOffer: "Por favor revise su oferta ahora.",
    },
    rebind: {
      title: "Cambiar contrato",
      titleConnect: "Conectar un contrato",
      intro:
        "Su cuenta muestra un contrato a la vez. Cámbielo a otro contrato a su nombre cuando necesite pagar o verlo. Puede volver. Los métodos de pago se quedan en el contrato donde los guardó.",
      introConnect:
        "Este inicio de sesión aún no está en un contrato. Conéctelo a un contrato a su nombre para pagar o ver esa cuenta.",
      connectedNow: "Está en",
      youAreOn: "Está en",
      unitStatus: "Unidad {{unit}} · {{status}}",
      none: "No tiene otro contrato a su nombre.",
      noneConnect:
        "Aún no hay un contrato a su nombre disponible para conectar.",
      switchTo: "Cambiar a este contrato",
      connectTo: "Conectar a este contrato",
      switch: "Cambiar",
      connect: "Conectar",
      cancel: "Cancelar",
      homeOffer: "Conectar a {{target}}",
      noLeaseTitle: "Conecte este inicio de sesión a un contrato",
      noLeaseSingle:
        "Este inicio de sesión aún no está en un contrato. Conéctelo a {{place}} para pagar y ver esa cuenta.",
      noLeaseChoose:
        "Este inicio de sesión aún no está en un contrato. Elija el contrato que necesita pagar o ver.",
      chooseLease: "Elegir un contrato",
      confirmSwitch:
        "¿Cambiar de {{from}} ({{fromStatus}}) a {{to}} ({{toStatus}})? Puede volver. Los métodos de pago se quedan en el contrato donde los guardó.",
      confirmConnect:
        "¿Conectar su cuenta a {{to}} ({{toStatus}})? Puede cambiar más tarde. Los métodos de pago se quedan en el contrato donde los guardó.",
      error: "No se pudo cambiar ese contrato. Inténtelo de nuevo.",
      loadError: "No se pudieron cargar los contratos. Inténtelo de nuevo.",
    },
    noLeaseMessage: {
      title: "Sin contrato activo",
      description:
        "Actualmente no tiene un contrato activo o próximo con nosotros. Por favor ",
      contactLink: "contáctenos",
      descriptionEnd: " si cree que esto es un error.",
      viewApplications: "Si ha aplicado con nosotros, vea sus solicitudes ",
      here: "aquí",
    },
    moveInConditionBanner: {
      title: "Complete su formulario de condición de mudanza",
      content:
        "Informe defectos, daños, problemas de seguridad o inquietudes de plagas antes del {{dueDate}}.",
      button: "Iniciar formulario",
    },
    pendingApplications: {
      title: "Sus solicitudes",
      subtitle: "Estas solicitudes aún requieren su atención.",
      unit: "Unidad",
      moveInDate: "Fecha de mudanza",
      propertyFallback: "Propiedad",
      statusIncomeNeeded: "Ingresos pendientes",
    },
    welcomMessageModal: {
      content: "Gracias por registrarse en TenantPort. Ahora tienes acceso a:",
      block1: {
        heading: "Pagos sin complicaciones",
        content: `No más cheques, no más sellos. Paga tu alquiler a tu conveniencia desde cualquier lugar y en cualquier momento. O déjelo en AutoPago para no perder ningún pago.`,
      },
      block2: {
        heading: "Solicitudes de mantenimiento rápido",
        content: `¿Encontró un problema? Envíe una solicitud de mantenimiento con solo unos pocos toques con una foto y nuestro equipo estará disponible en poco tiempo.`,
      },
      block3: {
        heading: "Informes de alquiler",
        content: `Aumente su puntaje crediticio simplemente pagando el alquiler. Con nuestra nueva aplicación, sus pagos puntuales ahora pueden reflejarse positivamente en su informe crediticio.`,
      },
    },
  },
};
